(() => {
  const root = document.querySelector('[data-cg-product-specs]');
  if (!root) return;

  const variantsNode = document.querySelector('[data-cg-product-variants]');
  const variants = variantsNode ? JSON.parse(variantsNode.textContent || '[]') : [];
  const specs = window.ColorfulGirlSkuSpecs || {};
  const byId = new Map(variants.map((variant) => [String(variant.id), variant]));

  const normalizeText = (value) => String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();

  const brandAliases = [
    [/colorful\s*girl/i, 'COLORFUL GIRL'],
    [/nebul(?:a|n)flow/i, 'NEBULAFLOW'],
    [/xuanfeier/i, 'XUANFEIER'],
    [/jiaoyanshe|jiao\s*yan\s*she/i, 'JIAOYANSHE'],
    [/vendeeni|vedenni/i, 'VENDEENI'],
    [/qing\s*you|qingyou/i, 'QINGYOU'],
    [/very\s*good(?:\s*nail)?/i, 'VERY GOOD NAIL'],
    [/l[’'`]\s*ugx|lugx/i, "L'UGX"],
    [/milan/i, 'MILAN'],
    [/snrqi/i, 'SNRQI'],
    [/sanmo/i, 'SANMO'],
    [/sansu/i, 'SANSU'],
    [/youth\s*rose/i, 'YOUTH ROSE'],
    [/yuriao/i, 'YURIAO'],
    [/venalisa/i, 'VENALISA'],
    [/ezflow/i, 'EZFLOW'],
    [/sunuv/i, 'SUNUV'],
  ];

  const cleanMarketplaceTitle = (value) => {
    let title = normalizeText(value)
      .replace(/^["“”'‘’]+|["“”'‘’]+$/g, '')
      .replace(/[【\[]\s*(?:พร้อมส่ง(?:ในไทย)?|สินค้าพร้อมส่ง|สินค้าใหม่)\s*[】\]]/gi, ' ')
      .replace(/[🔥✨🎄🎉💅🌈🌹💖🎁⭐🇹🇭]/gu, ' ')
      .replace(/พร้อมส่ง(?:ในไทย)?/gi, ' ')
      .replace(/ส่งไว!?/gi, ' ')
      .replace(/สินค้าใหม่|มาใหม่(?:ล่าสุด)?|สินค้าขายดี/gi, ' ')
      .replace(/\s*[|｜]\s*/g, ' | ')
      .replace(/\s+/g, ' ')
      .trim();

    title = title
      .replace(/\s*(?:แถมฟรี?|ฟรี)\s*ชาร์(?:ต|ท)สี.*$/i, '')
      .replace(/\s*\((?:ทา)?ชาร์(?:ต|ท)สี.*$/i, '')
      .replace(/\s+/g, ' ')
      .trim();

    return title;
  };

  const shorten = (value, maxLength) => {
    const text = normalizeText(value);
    if (text.length <= maxLength) return text;
    const candidate = text.slice(0, maxLength + 1);
    const breakAt = Math.max(candidate.lastIndexOf(' '), candidate.lastIndexOf('·'));
    return `${candidate.slice(0, breakAt > maxLength * 0.65 ? breakAt : maxLength).trim()}…`;
  };

  const splitDisplayTitle = (rawTitle) => {
    const cleaned = cleanMarketplaceTitle(rawTitle);
    const brandMatch = brandAliases.find(([pattern]) => pattern.test(cleaned));
    const brand = brandMatch?.[1] || 'COLORFUL GIRL';
    let title = cleaned;

    if (brandMatch) title = normalizeText(title.replace(brandMatch[0], ''));
    title = title.replace(/^[-–—·|/\s]+/, '');

    let parts = title.split(/\s*[|｜]\s*/).filter(Boolean);
    if (parts.length === 1 && title.length > 58) {
      const benefitStarts = ['ฟีล', 'ขับผิว', 'เนื้อเจล', 'สีแน่น', 'เหมาะสำหรับ', 'ลุค', 'ประกาย', 'ช่วยให้'];
      const benefitAt = benefitStarts
        .map((phrase) => title.indexOf(phrase))
        .filter((index) => index >= 30)
        .sort((a, b) => a - b)[0];
      if (benefitAt) parts = [title.slice(0, benefitAt), title.slice(benefitAt)];
    }
    if (parts.length === 1 && title.length > 70) {
      const cutZone = title.slice(38, 68);
      const relativeBreak = Math.max(cutZone.lastIndexOf(' '), cutZone.lastIndexOf('·'));
      const cutAt = relativeBreak >= 0 ? 38 + relativeBreak : 62;
      parts = [title.slice(0, cutAt), title.slice(cutAt)];
    }

    return {
      brand,
      primary: shorten(parts.shift() || cleaned, 70),
      secondary: shorten(parts.join(' · ').replace(/^[-–—·|/\s]+/, ''), 105),
    };
  };

  const enhanceProductTitle = () => {
    const title = document.querySelector('.product-info__block-item[data-block-type="title"] .product-title');
    if (!title || title.dataset.cgEnhanced === 'true') return;

    const display = splitDisplayTitle(title.textContent);
    const eyebrow = document.createElement('p');
    eyebrow.className = 'cg-product-title__eyebrow';
    eyebrow.textContent = display.brand;

    title.textContent = '';
    const primary = document.createElement('span');
    primary.className = 'cg-product-title__primary';
    primary.textContent = display.primary;
    title.appendChild(primary);

    if (display.secondary) {
      const secondary = document.createElement('span');
      secondary.className = 'cg-product-title__secondary';
      secondary.textContent = display.secondary;
      title.appendChild(secondary);
    }

    title.parentNode.insertBefore(eyebrow, title);
    title.dataset.cgEnhanced = 'true';
  };

  const descriptionHeadings = new Map([
    ['ข้อมูลสินค้า', 'ข้อมูลสินค้า'],
    ['รายละเอียดสินค้า', 'รายละเอียดสินค้า'],
    ['จุดเด่นสินค้า', 'จุดเด่นสินค้า'],
    ['จุดเด่น', 'จุดเด่นสินค้า'],
    ['คุณสมบัติเด่น', 'จุดเด่นสินค้า'],
    ['วิธีใช้', 'วิธีใช้'],
    ['วิธีการใช้งาน', 'วิธีใช้'],
    ['ขั้นตอนทาเล็บเจล', 'วิธีใช้'],
    ['ภายในเซ็ต', 'สิ่งที่ได้รับ'],
    ['สิ่งที่ได้รับ', 'สิ่งที่ได้รับ'],
    ['หมายเหตุ', 'หมายเหตุ'],
    ['ข้อควรระวัง', 'ข้อควรระวัง'],
  ]);

  const descriptionStopMarkers = [
    'การจัดส่งและบริการหลังการขาย',
    'เราเป็นโกดังสินค้าออนไลน์',
    'ลูกค้าใหม่กด',
    'ถ้าประทับใจ',
    'หากสินค้าเกิดปัญหา',
    'ในกรณีที่ลูกค้ารีวิว',
    'ในกรณีถ้าลูกค้า',
  ];

  const detailKeyPattern = /^(ยี่ห้อ|ชื่อสินค้า|รุ่น|ประเภท|วัสดุ|ขนาด|สี|ความจุ|ปริมาณ|กำลังไฟ|จำนวน|ภายในเซ็ต)\s*[:：]\s*(.+)$/i;

  const enhanceProductDescription = () => {
    const prose = document.querySelector('.product-info__block-item[data-block-type="description"] .prose');
    if (!prose || prose.dataset.cgEnhanced === 'true') return;

    const originalMedia = [...prose.querySelectorAll('img, video, iframe')].map((node) => node.cloneNode(true));
    let lines = String(prose.innerText || '')
      .split(/\n+/)
      .map((line) => normalizeText(line))
      .filter(Boolean);

    const stopAt = lines.findIndex((line) => descriptionStopMarkers.some((marker) => line.includes(marker)));
    if (stopAt >= 0) lines = lines.slice(0, stopAt);
    if (!lines.length) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'cg-description';
    let section = null;
    let list = null;
    let detailList = null;

    const ensureSection = (heading = 'รายละเอียดสินค้า') => {
      if (section) return section;
      section = document.createElement('section');
      section.className = 'cg-description__section';
      const h2 = document.createElement('h2');
      h2.textContent = heading;
      section.appendChild(h2);
      wrapper.appendChild(section);
      list = null;
      detailList = null;
      return section;
    };

    const startSection = (heading) => {
      section = null;
      ensureSection(heading);
    };

    lines.forEach((rawLine) => {
      const line = rawLine.replace(/^[💅💖📦📍🟢✅✔️•▪︎◦\-–—\s]+/u, '').trim();
      if (!line) return;

      const exactHeading = descriptionHeadings.get(line.replace(/[:：]$/, '').trim());
      if (exactHeading) {
        startSection(exactHeading);
        return;
      }

      const headingPrefix = [...descriptionHeadings.entries()].find(([key]) => line.startsWith(`${key}:`) || line.startsWith(`${key}：`));
      if (headingPrefix) {
        startSection(headingPrefix[1]);
        const remainder = line.slice(headingPrefix[0].length + 1).trim();
        if (!remainder) return;
        const paragraph = document.createElement('p');
        paragraph.textContent = remainder;
        section.appendChild(paragraph);
        return;
      }

      const keyValue = line.match(detailKeyPattern);
      if (keyValue) {
        const current = ensureSection('ข้อมูลสินค้า');
        if (!detailList) {
          detailList = document.createElement('dl');
          detailList.className = 'cg-description__details';
          current.appendChild(detailList);
        }
        const row = document.createElement('div');
        const dt = document.createElement('dt');
        const dd = document.createElement('dd');
        dt.textContent = keyValue[1];
        dd.textContent = keyValue[2];
        row.append(dt, dd);
        detailList.appendChild(row);
        return;
      }

      const numbered = line.match(/^\d+[.)]?\s*(.+)$/);
      const wasBullet = /^[💅💖📦📍🟢✅✔️•▪︎◦\-–—]/u.test(rawLine.trim());
      if (numbered || wasBullet) {
        const current = ensureSection();
        const listTag = numbered ? 'OL' : 'UL';
        if (!list || list.tagName !== listTag) {
          list = document.createElement(listTag.toLowerCase());
          current.appendChild(list);
        }
        const item = document.createElement('li');
        item.textContent = numbered ? numbered[1] : line;
        list.appendChild(item);
        return;
      }

      const paragraph = document.createElement('p');
      paragraph.textContent = line;
      ensureSection().appendChild(paragraph);
      list = null;
    });

    if (originalMedia.length) {
      const media = document.createElement('div');
      media.className = 'cg-description__media';
      originalMedia.forEach((node) => media.appendChild(node));
      wrapper.appendChild(media);
    }

    prose.textContent = '';
    prose.appendChild(wrapper);
    prose.dataset.cgEnhanced = 'true';
  };

  const normalizeSkuExact = (value) =>
    String(value || '').trim().toUpperCase().replaceAll(' ', '').replace(/^'/, '').replace(/^61064-/, '');

  const normalizeSku = (value) => {
    const cleaned = normalizeSkuExact(value);
    const parts = cleaned.split('-');
    if (/^\d+$/.test(parts.at(-1) || '')) parts[parts.length - 1] = String(Number(parts.at(-1)));
    return parts.join('-');
  };

  const skuLookupKeys = (value) => {
    const exact = normalizeSkuExact(value);
    const aliases = [exact, normalizeSku(exact)];
    if (exact.startsWith('NF-')) {
      const legacy = `AF-${exact.slice(3)}`;
      aliases.push(legacy, normalizeSku(legacy));
    }
    return [...new Set(aliases)];
  };

  const formatWeight = (grams) => {
    const value = Number(grams || 0);
    if (!value) return 'กำลังตรวจสอบ';
    return `${(value / 1000).toLocaleString('th-TH', { maximumFractionDigits: 3 })} KG`;
  };

  const findCurrentVariant = (preferredId) => {
    if (preferredId && byId.has(String(preferredId))) return byId.get(String(preferredId));
    const formInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (formInput && byId.has(String(formInput.value))) return byId.get(String(formInput.value));
    const urlId = new URL(window.location.href).searchParams.get('variant');
    if (urlId && byId.has(String(urlId))) return byId.get(String(urlId));
    return variants.find((variant) => variant.available) || variants[0];
  };

  const render = (variant) => {
    if (!variant) return;
    const sku = String(variant.sku || '').trim();
    const spec = skuLookupKeys(sku).map((key) => specs[key]).find(Boolean) || null;
    const weight = spec?.weightG || variant.weight || 0;
    const dimensions = spec?.lengthCm && spec?.widthCm && spec?.heightCm
      ? `${spec.lengthCm} × ${spec.widthCm} × ${spec.heightCm} ซม.`
      : 'กำลังตรวจสอบ';
    const verified = Boolean(spec?.lengthCm && spec?.widthCm && spec?.heightCm);

    root.innerHTML = `
      <div class="cg-specs__heading">รายละเอียดสินค้า</div>
      <dl class="cg-specs__grid">
        <div><dt>SKU</dt><dd>${sku || 'กำลังตรวจสอบ'}</dd></div>
        <div><dt>น้ำหนักสินค้า</dt><dd>${formatWeight(weight)}</dd></div>
        <div><dt>ขนาดแพ็ก (ย × ก × ส)</dt><dd>${dimensions}</dd></div>
      </dl>
      <p class="cg-specs__note">${verified ? 'ตรวจสอบกับข้อมูลคลังสินค้าแล้ว' : 'ข้อมูลขนาดอยู่ระหว่างตรวจสอบกับคลังสินค้า'}</p>
    `;
  };

  const insertNearPurchase = () => {
    const anchor = document.querySelector('.product-info__buy-buttons, buy-buttons, [data-product-form], form[action*="/cart/add"]');
    if (anchor && !root.parentElement?.classList.contains('cg-specs-anchor')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'cg-specs-anchor';
      anchor.parentNode.insertBefore(wrapper, anchor);
      wrapper.appendChild(root);
      root.hidden = false;
    }
  };

  const update = (variantId) => render(findCurrentVariant(variantId));
  insertNearPurchase();
  enhanceProductTitle();
  enhanceProductDescription();
  update(root.dataset.initialVariantId);

  document.addEventListener('change', () => window.setTimeout(() => update(), 0));
  document.addEventListener('variant:change', (event) => update(event.detail?.variant?.id));
  document.addEventListener('product:variant-change', (event) => update(event.detail?.variant?.id));

  let lastVariantId = '';
  window.setInterval(() => {
    const current = findCurrentVariant();
    if (current && String(current.id) !== lastVariantId) {
      lastVariantId = String(current.id);
      insertNearPurchase();
      enhanceProductTitle();
      enhanceProductDescription();
      render(current);
    }
  }, 500);
})();
